import { OrderItem } from "@omni/types/api/cart/bff/shared/orderItem.model";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type ReferenceComponentProps = {
    item: OrderItem;
};

const ReferenceComponent = ({ item }: ReferenceComponentProps) => {
    const { t } = useGranite();

    if (item.warrantyDeposit || item.articleConfiguration) {
        return null;
    }

    return (
        <p className={"m-0"}>
            {t("orderOverview.product.reference", item.sku)}
        </p>
    );
};

export { ReferenceComponent };
